// Collegamento a Firebase. Senza configurazione vera l'app parte in «modalità prova»
// e usa il simulatore locale (npm run dev con gli emulatori, oppure le prove automatiche).
import { initializeApp } from 'firebase/app';
import {
  initializeFirestore, persistentLocalCache, persistentMultipleTabManager, connectFirestoreEmulator,
} from 'firebase/firestore';
import { getAuth, connectAuthEmulator, signInAnonymously, onAuthStateChanged } from 'firebase/auth';

const env = import.meta.env || {};

export const configurazione = env.VITE_FB_API_KEY
  ? {
      apiKey: env.VITE_FB_API_KEY,
      authDomain: env.VITE_FB_AUTH_DOMAIN,
      projectId: env.VITE_FB_PROJECT_ID,
      appId: env.VITE_FB_APP_ID,
    }
  : { apiKey: 'prova', projectId: 'demo-spa', authDomain: 'demo-spa.firebaseapp.com', appId: 'prova' };

export const modalitaProva = !env.VITE_FB_API_KEY;

export function avviaFirebase() {
  const app = initializeApp(configurazione);
  // Cache sul telefono: ogni azione si salva subito qui e parte appena c'è rete (offline-first).
  const db = initializeFirestore(app, {
    localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
  });
  const auth = getAuth(app);
  if (modalitaProva) {
    const host = env.VITE_EMULATORE_HOST || '127.0.0.1';
    connectFirestoreEmulator(db, host, 8080);
    connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
  }
  return { app, db, auth };
}

// Ogni telefono ha un'identità anonima che resta sul telefono: niente password per il personale.
// Entra davvero solo dopo l'approvazione della responsabile (regole di sicurezza).
export function utenteCollegato(auth) {
  return new Promise((risolvi, rifiuta) => {
    const stop = onAuthStateChanged(auth, (u) => {
      if (u) { stop(); risolvi(u); return; }
      signInAnonymously(auth).catch((e) => { stop(); rifiuta(e); });
    }, rifiuta);
  });
}
